<template>
  <b-modal
    id="newcopy-modal"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    ok-title="Crea"
    title="Crea una nuova copia"
    @ok="makeCopy"
  >
    <b-form>
      <b-form-group>
        <label for="name">Nome:</label>
        <b-form-input
          id="name"
          v-model="label"
          placeholder="Nome Copia"
          type="text"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import * as commonHelpers from '@/helpers/common-helpers'
import objectsRepository from '@/api/objectsRepository'
import useMyStore from '@/services/useMyStore'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'NewCopyModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  props: {
    files: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const { currentObject } = useMyStore()
    return { currentObject }
  },
  data() {
    return {
      status: false,
      label: '',
    }
  },
  watch: {
    currentObject(val) {
      const file = this.files.find(el => el.id === val)
      this.label = this.commonHelpers.renameFile(file ? file.label : '', '1')
    },
  },
  methods: {
    async makeCopy() {
      this.$emit('loading', true)
      const { data } = await objectsRepository.makeCopy(this.currentObject, {
        label: this.label,
      })
      if (data.code) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Successo!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$emit('refresh')
      } else {
        console.log('error make copy')
      }
    },
  },
}
</script>

<style scoped>

</style>
